import { pushEvent } from '../helpers.js';

const pushDrawerEventToDataLayer = ({ siteFeature , interactionType  })=>{
    pushEvent({
        event: 'drawer_trigger_click',
        site_feature: siteFeature,
        interaction_type: interactionType
    });
};

export { pushDrawerEventToDataLayer };
//# sourceMappingURL=drawer.js.map
